import { render, staticRenderFns } from "./DuelChallenge_Section_Title.vue?vue&type=template&id=0c419946&"
import script from "./DuelChallenge_Section_Title.vue?vue&type=script&lang=js&"
export * from "./DuelChallenge_Section_Title.vue?vue&type=script&lang=js&"
import style0 from "./DuelChallenge_Section_Title.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports